export default {
  labels: {
    google_place: 'Lieu Google',
    live: 'En ligne',
    setting_up: 'Configuration',
  },
  buttons: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
    continue_setup: 'Continuer la configuration',
  },
  delete_confirmation: 'Êtes-vous sûr ?',
};
